export const adaptProfesionalRI = (profesional) => {
    return {
        profesionalRI: {
            profesionalRI: profesional?.profesionalRIById?.profesionalRI?.map(x => x.idTipoProfesional),
            profesionalEspecialidadRI: profesional?.profesionalRIById?.profesionalEspecialidadRI?.map(x => x.idEspecialidad)
        }
    }
}

export const adaptProfesionalRIArray = (
    profesional
) => {
    return structuredClone(profesional?.profesionalRIById)
        ?.map(profesional => adaptProfesionalRI(profesional));
}